import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../state";
import { IPaymentState, paymentActions } from "../../state/payment";
import { ICardItemResponse } from "../card-list/card-list.interface";

export const useCardDetailStore = () => {
  const dispatch = useDispatch();
  const { cardSelected, isCardUpdateInitiated } = useSelector((state: IRootState) => state.payment as IPaymentState);

  const setCardSelected = (card: ICardItemResponse | null) => {
    dispatch(paymentActions.setCardSelected(card));
  };

  const setCardUpdateStatus = (isCardUpdateInitiated: boolean) => {
    dispatch(paymentActions.setCardUpdateStatus(isCardUpdateInitiated));
  };

  return {
    setCardSelected,
    setCardUpdateStatus,
    cardSelected,
    isCardUpdateInitiated,
  };
};
